import script from "./FinalFormScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalFormScreen.vue?vue&type=script&setup=true&lang=ts"

import "./FinalFormScreen.vue?vue&type=style&index=0&id=5c8e412c&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c8e412c"]])

export default __exports__